import { LitElement, html, css, unsafeCSS } from 'lit'
import { customElement, state } from 'lit/decorators.js'
import { t } from '../utils/i18n.js'
import styles from './about-page.css?inline'

/**
 * About page component
 */
@customElement('about-page')
export class AboutPage extends LitElement {
  @state() private _updateTrigger = 0

  connectedCallback() {
    super.connectedCallback()
    // Listen for i18n updates
    window.addEventListener('i18n-updated', () => {
      this._updateTrigger++
      this.requestUpdate()
    })
  }
  static styles = css`${unsafeCSS(styles)}`

  render() {
    return html`
      <h1>${t('about.title')}</h1>
      
      <p>
        ${t('about.description1')}
      </p>

      <p>
        ${t('about.description2')}
      </p>

      <div class="tech-stack">
        <h2>${t('about.techStack')}</h2>
        <ul class="tech-list">
          <li><strong>${t('about.techVite')}</strong></li>
          <li><strong>${t('about.techLit')}</strong></li>
          <li><strong>${t('about.techTypeScript')}</strong></li>
          <li><strong>${t('about.techGraphQL')}</strong></li>
          <li><strong>${t('about.techPostgreSQL')}</strong></li>
        </ul>
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'about-page': AboutPage
  }
}
